<template>
  <div class="video-container w-full">
    <!-- No `crossorigin` here on purpose - see mixins/captionedVideo.js. -->
    <video :id="playerId" :controls="true" :poster="poster">
      <source :src="src" type="video/mp4" />
      <!-- Captions (SC 1.2.2): the .vtt beside the MP4. -->
      <track
        v-if="captionsUrl"
        kind="captions"
        label="English"
        srclang="en"
        :src="captionsUrl"
        default
        @load="onCaptionsLoad"
        @error="onCaptionsError"
      />
    </video>
    <!-- Text alternative (SC 1.2.3), built from the caption cues once they have loaded. -->
    <details v-if="transcriptText" class="video-transcript mt-3">
      <summary>Video transcript</summary>
      <p class="mt-2">{{ transcriptText }}</p>
    </details>
  </div>
</template>

<script>
import captionedVideo from '@/mixins/captionedVideo';

// Several of these render on a page, so the id must be unique per instance.
let uid = 0;

export default {
  mixins: [captionedVideo],
  props: ['src', 'posterimg'],
  data() {
    uid += 1;
    return { playerId: `responsive-video-player-${uid}` };
  },
  computed: {
    poster() {
      if (typeof this.$props.posterimg !== 'undefined') {
        return this.$props.posterimg;
      } else {
        return null;
      }
    },
    // Inputs for the captionedVideo mixin.
    videoSourceUrl() {
      return this.src;
    },
    explicitCaptions() {
      return '';
    },
    explicitTranscript() {
      return '';
    },
  },
};
</script>

<style scoped>
/*iframe {
    width: 100%;
    height: 100vh;
    margin: 20px 0;
  }*/
video {
  width: 100%;
  height: auto;
}
video {
  object-fit: cover;
}
video {
  object-fit: fill;
}
</style>
